/* eslint-disabled */

export default class VoucherGroupExtend {


  constructor (object?: any) {
  }

  postConstruct () {
  }
}
